module.exports = __webpack_public_path__ + "static/banner-dev-c1a70c9d60672080f8bab2d1c0608a1c.png";